import { React, useState } from "react";
import styled from '@emotion/styled'
import * as Const from "./const.js"

const Url = ({children, href}) => {

    const theUrl = encodeURI(href);

    const A = styled.div`
        padding: 16px;
        margin: 10px 0;
        background-color: #222;
        border-radius: 5px;
        width: 100%;
        overflow: scroll;
        

        a {
            color: ${Const.linkColor};
            text-decoration: none;
        }
    `

    return (    

        <A>
            <small>
                Your URL: <br />
            <a href={theUrl} target="_blank">
                {theUrl}
            </a>
            </small>
        </A>

    );
    
}

export default Url